module.exports = __webpack_public_path__ + "img/lamartine.13ef944c.png";